module.exports = __webpack_public_path__ + "static/img/product04-2.66e0ad9d.png";